module.exports = __webpack_public_path__ + "media/images/amenities_icons/childcare-1fbbd0ec45e20c4e003ddf916f6381cf.svg";